import KroConstants from "common/constants/kroConstants";


export  function getCampaignDefaultImage(category: string): string {
    const images = KroConstants.CAMPAIGN_DEFAULT_IMAGE_URLS;
    return images.get(category) || images.get("default")!;
}